/* Perfume Gyaan PDP image zoom.
   Desktop: hover the main image to magnify (follows the cursor).
   All devices: click/tap the main image to open a full-screen viewer with
   prev/next, tap to zoom, drag to pan, pinch to zoom. */
(function(){
  var main = document.querySelector('.main-img[data-zoom]');
  var img = document.getElementById('pgMain');
  var box = document.getElementById('pgZoom');
  if (!main || !img || !box) return;

  var HOVER = 2, MAX = 4;
  var canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function hiRes(src){
    if (!src) return src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$12000') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2000';
  }

  /* ---- hover zoom on the main image (desktop only) ---- */
  if (canHover) {
    main.addEventListener('mousemove', function(e){
      var r = main.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      img.style.transform = 'scale(' + HOVER + ')';
      main.classList.add('zooming');
    });
    main.addEventListener('mouseleave', function(){
      img.style.transform = '';
      main.classList.remove('zooming');
    });
  }

  /* ---- full-screen viewer ---- */
  var stage = box.querySelector('.pz-stage');
  var big = box.querySelector('.pz-img');
  var count = box.querySelector('.pz-count');
  var prevBtn = box.querySelector('.pz-prev');
  var nextBtn = box.querySelector('.pz-next');
  var list = [], idx = 0, scale = 1, tx = 0, ty = 0, lastFocus = null;

  /* each entry: { low: already-cached 1200px src, high: 2000px src } */
  function sources(){
    var thumbs = document.querySelectorAll('#pgThumbs .thumb');
    var out = [];
    thumbs.forEach(function(t){ var s = t.getAttribute('data-full'); out.push({ low: s, high: hiRes(s) }); });
    if (!out.length) out.push({ low: img.src, high: hiRes(img.src) });
    return out;
  }

  function path(src){ return (src || '').split('?')[0].replace(/^https?:/, ''); }

  function apply(animate){
    big.style.transition = animate ? 'transform .3s cubic-bezier(.22,1,.36,1)' : 'none';
    big.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    box.classList.toggle('pz-zoomed', scale > 1);
  }

  function clamp(){
    var w = stage.clientWidth, h = stage.clientHeight;
    var mx = (w * (scale - 1)) / 2, my = (h * (scale - 1)) / 2;
    tx = Math.max(-mx, Math.min(mx, tx));
    ty = Math.max(-my, Math.min(my, ty));
  }

  function reset(){ scale = 1; tx = 0; ty = 0; apply(false); }

  function show(i){
    idx = (i + list.length) % list.length;
    reset();
    var item = list[idx];
    big.src = item.low;
    var hi = new Image();
    hi.onload = function(){ if (list[idx] === item) big.src = item.high; };
    hi.src = item.high;
    count.textContent = (idx + 1) + ' / ' + list.length;
    var multi = list.length > 1;
    prevBtn.hidden = nextBtn.hidden = count.hidden = !multi;
  }

  function open(){
    list = sources();
    /* start on whatever the main image shows (thumb click or variant change) */
    var cur = path(img.src), start = 0;
    for (var i = 0; i < list.length; i++) { if (path(list[i].low) === cur) { start = i; break; } }
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('pz-lock');
    show(start);
    box.querySelector('.pz-close').focus();
  }

  function close(){
    box.hidden = true;
    document.documentElement.classList.remove('pz-lock');
    reset();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* zoom to a point (client coords) */
  function zoomAt(cx, cy, s){
    var r = stage.getBoundingClientRect();
    var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
    var k = s / scale;
    tx = ox - (ox - tx) * k;
    ty = oy - (oy - ty) * k;
    scale = s;
    clamp();
  }

  main.addEventListener('click', function(e){
    if (e.target.closest('.gwish')) return;
    open();
  });
  main.addEventListener('keydown', function(e){
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
  });

  box.querySelector('.pz-close').addEventListener('click', close);
  prevBtn.addEventListener('click', function(){ show(idx - 1); });
  nextBtn.addEventListener('click', function(){ show(idx + 1); });
  box.addEventListener('click', function(e){ if (e.target === box) close(); });

  document.addEventListener('keydown', function(e){
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft' && list.length > 1) show(idx - 1);
    else if (e.key === 'ArrowRight' && list.length > 1) show(idx + 1);
  });

  /* pointer gestures: tap toggles zoom, drag pans, pinch zooms, swipe changes image */
  var pts = {}, startDist = 0, startScale = 1, moved = false, downX = 0, downY = 0, lastX = 0, lastY = 0;

  function dist(){
    var p = Object.keys(pts).map(function(k){ return pts[k]; });
    return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
  }
  function mid(){
    var p = Object.keys(pts).map(function(k){ return pts[k]; });
    return { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 };
  }

  stage.addEventListener('pointerdown', function(e){
    stage.setPointerCapture(e.pointerId);
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (Object.keys(pts).length === 2) { startDist = dist(); startScale = scale; }
    moved = false; downX = lastX = e.clientX; downY = lastY = e.clientY;
  });

  stage.addEventListener('pointermove', function(e){
    if (!pts[e.pointerId]) return;
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    var n = Object.keys(pts).length;
    if (n === 2) {
      var m = mid();
      zoomAt(m.x, m.y, Math.max(1, Math.min(MAX, startScale * dist() / startDist)));
      moved = true; apply(false);
    } else if (n === 1) {
      if (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6) moved = true;
      if (scale > 1) {
        tx += e.clientX - lastX; ty += e.clientY - lastY;
        clamp(); apply(false);
      }
      lastX = e.clientX; lastY = e.clientY;
    }
  });

  function up(e){
    if (!pts[e.pointerId]) return;
    var wasPinch = Object.keys(pts).length > 1;
    delete pts[e.pointerId];
    if (wasPinch) { if (scale <= 1.02) reset(); return; }
    var dx = e.clientX - downX;
    if (!moved) {
      if (scale > 1) { reset(); apply(true); }
      else { zoomAt(e.clientX, e.clientY, 2.5); apply(true); }
    } else if (scale === 1 && list.length > 1 && Math.abs(dx) > 60) {
      show(idx + (dx < 0 ? 1 : -1));
    }
  }
  stage.addEventListener('pointerup', up);
  stage.addEventListener('pointercancel', function(e){ delete pts[e.pointerId]; });

  stage.addEventListener('wheel', function(e){
    e.preventDefault();
    var s = Math.max(1, Math.min(MAX, scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15)));
    zoomAt(e.clientX, e.clientY, s);
    if (s === 1) { tx = 0; ty = 0; }
    apply(false);
  }, { passive: false });
})();
